import {
  APP_BUILD_VERSION,
  FX_TRANSACTION_ADD_PREFIX,
  TRANSACTION_ADD_PREFIX,
} from 'constants';
import Cookies from 'helpers/cookies';
import { requestReload } from 'helpers/reloadGate';
import sw from 'helpers/sw';
import { isFunction } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { DETECT_BUILD_VERSION_SW } from 'store/version/config';

export function useBuildDetector() {
  const [newBuildDetected, setNewBuildDetected] = useState(false);

  const triggerRefreshRef = useRef(null);

  const pathsTriggerReloadLater = [
    TRANSACTION_ADD_PREFIX,
    FX_TRANSACTION_ADD_PREFIX,
  ];

  const refreshApp = () => {
    requestReload(() => window.location.reload(true));
  };

  const requestBuildDetectorApiSubcribe = () => {
    if (sw.isLocalhost()) {
      console.error(
        `🔥 useBuildDetector ❌ requestBuildDetectorApiSubcribe ➡️ ERROR ➡️ Build detector is't working on localhost! ↩`
      );
      return;
    }
    if (!('serviceWorker' in navigator)) {
      console.error(
        `🔥 useBuildDetector ❌ requestBuildDetectorApiSubcribe ➡️ ERROR ➡️ Service Worker doesn't supported! ↩`
      );
      return;
    }
    navigator.serviceWorker
      .register(DETECT_BUILD_VERSION_SW)
      .then((registration) => {
        const COUNTDOWN_TIMER_UPDATE = 30000;
        setInterval(() => {
          console.log(
            `⭐ useBuildDetector 👉 requestBuildDetectorApiSubcribe ➡️ sw ➡️ UPDATED ↩`
          );
          registration?.update();
        }, COUNTDOWN_TIMER_UPDATE);
      })
      .catch((error) =>
        console.error(
          `🔥 useBuildDetector ❌ requestBuildDetectorApiSubcribe ➡️ sw ➡️ ERROR ↩`,
          error?.message
        )
      );
  };

  useEffect(() => {
    if (sw.isLocalhost()) {
      console.error(
        `🔥 useBuildDetector ❌ useEffect ➡️ ERROR ➡️ Build detector is't working on localhost! ↩`
      );
      return;
    }
    if (!('serviceWorker' in navigator)) {
      console.error(
        `🔥 useBuildDetector ❌ useEffect ➡️ ERROR ➡️ Service Worker doesn't supported! ↩`
      );
      return;
    }
    const onMessage = (event) => {
      console.log(
        `⭐ useBuildDetector 👉 onMessage ➡️ NEW_BUILD ➡️ event ↩`,
        event
      );
      if (event?.data?.type === 'NEW_BUILD') {
        const newVersion = event.data.version;
        const storedVersion = Cookies.get(APP_BUILD_VERSION);
        console.log(
          `⭐ useBuildDetector 👉 onMessage ➡️ NEW_BUILD ➡️ newVersion ↩`,
          newVersion
        );
        console.log(
          `⭐ useBuildDetector 👉 onMessage ➡️ NEW_BUILD ➡️ storedVersion ↩`,
          storedVersion
        );

        if (storedVersion === newVersion) {
          return;
        }

        Cookies.set(APP_BUILD_VERSION, newVersion);

        if (pathsTriggerReloadLater.includes(window.location.pathname)) {
          console.log(
            `⭐ useBuildDetector 👉 onMessage ➡️ NEW_BUILD ➡️ Trigger reload later! ↩`
          );
          triggerRefreshRef.current = () => setNewBuildDetected(true);
        } else {
          console.log(
            `⭐ useBuildDetector 👉 onMessage ➡️ NEW_BUILD ➡️ Trigger instant reload! ↩`
          );
          setNewBuildDetected(true);
        }
      }
    };
    navigator.serviceWorker?.addEventListener('message', onMessage);
    return () => {
      navigator.serviceWorker?.removeEventListener('message', onMessage);
    };
  }, []);
  useEffect(() => {
    const onUserInteract = () => {
      if (!pathsTriggerReloadLater.includes(window.location.pathname)) {
        if (isFunction(triggerRefreshRef.current)) {
          console.log(
            `⭐ useBuildDetector 👉 onUserInteract ➡️ NEW_BUILD ➡️ Trigger reload later! ➡️ RUNNING ↩`
          );
          triggerRefreshRef.current?.();
          triggerRefreshRef.current = null;
        }
      }
    };
    window.addEventListener('mousedown', onUserInteract, true);
    window.addEventListener('touchstart', onUserInteract, true);
    return () => {
      window.removeEventListener('mousedown', onUserInteract, true);
      window.removeEventListener('touchstart', onUserInteract, true);
    };
  }, []);

  return { requestBuildDetectorApiSubcribe, newBuildDetected, refreshApp };
}
